import * as React from 'react';
import {
  Button,
  TextField,
  Box,
  FormGroup,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Typography,
  Fab,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from '@mui/material';
import './AddAsset3.css';
import {Row,Col} from 'react-bootstrap';
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Update as UpdateIcon,
  Upload as UploadIcon,
  Close as CloseIcon,
  SaveAlt as SaveAltIcon,
} from '@mui/icons-material';
import ImageUploading from 'react-images-uploading';

const selectedCities = [
  {
    countryCode: 'PK',
    latitude: '24.86080000',
    longitude: '67.01040000',
    name: 'Karachi',
    stateCode: 'SD',
  },
  {
    countryCode: 'PK',
    latitude: '31.55800000',
    longitude: '74.35071000',
    name: 'Lahore',
    stateCode: 'PB',
  },
  {
    countryCode: 'PK',
    latitude: '33.72148000',
    longitude: '73.04329000',
    name: 'Islamabad',
    stateCode: 'IS',
  },
];

export default function AddAsset3({handlePrevious,handleNext,order}) {
  const [images, setImages] = React.useState([]);
  const [captainInfoCount, setCaptainInfoCount] = React.useState(1);
  const [crewCount, setCrewCount] = React.useState(1);
  const [hourLimit, setHourLimit] = React.useState(12);
  const [diffPricing, setDiffPricing] = React.useState(false);
  const [inclPricing, setInclPricing] = React.useState(true);
  const [termRate, setTermRate] = React.useState(false);
  const [numberOfWholeSaleDays, setNumberOfWholeSaleDays] = React.useState(0);
  const [capInfo, setCapInfo] = React.useState([
    <>

      <Row>
      <p className='sleepingTxt'>Captain-{captainInfoCount}</p>
      </Row>
      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='First Name' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Last Name' />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='#' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='@' />
        </Col>
      </Row>

    </>,
  ]);
  const [crewMembers, setCrewMembers] = React.useState([
    <>
      <br />
      <br />
      <Row>
      <p className='sleepingTxt' style={{marginTop:'-20px'}}>Crew Member-{crewCount}</p>
      </Row>

      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Crew Member' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Fees' />
        </Col>
      </Row>

    </>,
  ]);

  const handleAddCaptainInfoForm = () => {
    setCaptainInfoCount((prev) => prev + 1);
    setCapInfo((prev) =>
      prev.concat(
        <>
          <br />
          <br />

      <Row>
      <p className='sleepingTxt'>Captain-{captainInfoCount + 1}</p>
      </Row>
      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='First Name' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Last Name' />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='#' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='@' />
        </Col>
      </Row>

        </>,
      ),
    );
  };

  const handleAddCrewForm = () => {
    setCrewCount((prev) => prev + 1);
    setCrewMembers((prev) =>
      prev.concat(
        <>
          <br />
          <br />
      <Row>
      <p className='sleepingTxt' style={{marginTop:'-20px'}}>Crew Member-{crewCount + 1}</p>
      </Row>

      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Crew Member' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Fees' />
        </Col>
      </Row>

        </>,
      ),
    );
  };

  const onChange = (imageList, addUpdateIndex) => {
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  const handleRemoveCaptainInfoForm = () => {
    const val = [...capInfo];

    val.pop();

    setCaptainInfoCount((prev) => prev - 1);
    setCapInfo(val);
  };

  const handleRemoveCrewForm = () => {
    const val = [...crewMembers];

    val.pop();

    setCrewCount((prev) => prev - 1);
    setCrewMembers(val);
  };

  return (
    <div className='addAsset1_Main'>
      <Row>
      <p className='sleepingTxt'>Availability</p>
      </Row>

        <FormControlLabel
          control={<Checkbox defaultChecked />}
          label='Sunday'
        />
        <FormControlLabel control={<Checkbox />} label='Monday' />
        <FormControlLabel control={<Checkbox />} label='Tuesday' />
        <FormControlLabel control={<Checkbox />} label='Wednesday' />
        <FormControlLabel control={<Checkbox />} label='Thursday' />
        <FormControlLabel control={<Checkbox />} label='Friday' />
        <FormControlLabel control={<Checkbox />} label='Saturday' />
      <br />
      <br />

      <Row>
      <p className='sleepingTxt'>Maximum book hours limit</p>
      </Row>
      <Row>
        <Col  sm={6}>
        <select
        placeholder='Maximum book hours limit'
            value={hourLimit}
         className='type addAsset1_Input'
          onChange={(e) => setHourLimit(e.target.value)}>
            {[1,2,3,4,5,6,7,8,9,10,11,12].map(v => (
              <option
                key={v}
                value={v}
                >
                {v}
              </option>
            ))}
        </select>

        </Col>
        <Col>
        </Col>
      </Row>

      <br />

      {selectedCities.map((city) => (
        <>
        <hr/>
      <Row>
      <p className='sleepingTxt'>Pricing from {city.name}</p>
      </Row>
      <Row>
            <FormControlLabel
            className='formControl_div'
              control={<Checkbox checked={termRate} />}
              onClick={() => setTermRate((prev) => !prev)}
              label='Do you offer term charters or only hourly?'
            />
      </Row>
      <Row>
            <FormControlLabel
            className='formControl_div'
              control={<Checkbox checked={diffPricing} />}
              onClick={() => setDiffPricing((prev) => !prev)}
              label='Do you have different pricing each day or is it the same?'
            />
      </Row>

            {diffPricing && (
              <>
                <br />
      <Row>
      <p className='sleepingTxt'>Price for each day</p>
      </Row>

      <Row>
        <Col  sm={6}>
        <input className='Title addAsset2_Input' placeholder='Sunday' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Monday' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Tuesday' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Wednesday' />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Thursday' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Friday' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Saturday' />
        </Col>
        <Col></Col>
      </Row>


              </>
            )}
      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Marina Pick-Up Fees' />
        </Col>
        <Col>
        </Col>
      </Row>

      <Row>
      <p className='sleepingTxt'>Price for each day</p>
      </Row>

      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='What is the fee for?' />
        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Amount' />
        </Col>
      </Row>


            {termRate && (
              <>
      <Row>
      <p className='sleepingTxt'>WholeSale term rate</p>
      </Row>
      <Row>
        <Col sm={6}>
        <select
        placeholder='Maximum book hours limit'
                      value={numberOfWholeSaleDays}
         className='type addAsset1_Input'
                      onChange={(e) =>
                        setNumberOfWholeSaleDays(e.target.value)
                      }>
            {[1,2,3,4,5,6,7].map(v => (
              <option
                key={v}
                value={v}
                >
                {v}
              </option>
            ))}
        </select>

        </Col>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Amount' />
        </Col>
      </Row>
              </>
            )}
          <br />
        </>
      ))}
      <Row>
      <FormControlLabel
            className='formControl_div'
        control={<Checkbox checked={inclPricing} />}
        onClick={() => setInclPricing((prev) => !prev)}
        label='Does this pricing include Fuel, Captain, Crew, and Gratuity?'
      />
      </Row>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minWidth: '80%',
          maxWidth:'90%',
          margin:'auto'
        }}>
      <Row>
      <p className='sleepingTxt'>Crew Members</p>
      </Row>
        <Box>
          <Fab
            sx={{ margin: '10px' }}
            disabled={inclPricing}
            color='primary'
            onClick={handleAddCrewForm}
            size='small'>
            <AddIcon fontSize='small'/>
          </Fab>
          <Fab
            sx={{ margin: '10px' }}
            color='primary'
            disabled={crewCount === 1}
            onClick={handleRemoveCrewForm}
            size='small'>
            <RemoveIcon fontSize='small'/>
          </Fab>
        </Box>
      </Box>

      <Row>
        <Col sm={6}>
        <input className='Title addAsset2_Input' placeholder='Captain Hourly Rate' />
        </Col>
        <Col></Col>
      </Row>

        {!inclPricing && crewMembers}

      <br />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minWidth: '80%',
          maxWidth:'90%',
          margin:'auto'
        }}>
      <Row>
      <p className='sleepingTxt'>Captain Information</p>
      </Row>
        <Box>
          <Fab
            sx={{ margin: '10px' }}
            color='primary'
            onClick={handleAddCaptainInfoForm}
            size='small'>
            <AddIcon fontSize='small'/>
          </Fab>
          <Fab
            sx={{ margin: '10px' }}
            color='primary'
            disabled={captainInfoCount === 1}
            onClick={handleRemoveCaptainInfoForm}
            size='small'>
            <RemoveIcon fontSize='small'/>
          </Fab>
        </Box>
      </Box>
        {capInfo}

      <div className='chngBtnDiv' >
      <button
        className='prevBtn'
        onClick={handlePrevious}
        disabled={order === 0}
        >
        Prev
      </button>
      <button
        className='nextBtn'
        // disabled={order === 3}
        onClick={handleNext}
        >
        Next
      </button>
      </div>
      <br />
    </div>
  );
}
